<template>
  <v-card class="pt-4 mx-auto" max-width="600">
    <v-card-title class="px-4"><span>{{ $t('mcerase.title') }}</span></v-card-title>
    <v-card-text>
    </v-card-text>
    <v-card-actions class="d-flex justify-center">
      <v-dialog v-model="confirmationDialogShow" persistent max-width="350" light>
        <template v-slot:activator="{ on }">
          <v-btn color="secondary" dark v-on="on" class="mx-2">
            {{ $t("mcerase.button")}}
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="d-flex justify-space-between">
            <span>{{ $t('mcerase.title') }}</span>
            <v-icon @click="closeEraseDialog">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-alert
              class="mt-4"
              type="error">
               {{ $t('mcerase.description') }}
            </v-alert>
            <v-checkbox
              v-model="confirmation"
              :label="$t('mcerase.confirmation')"
            ></v-checkbox>
            <v-btn color="primary" small :disabled="!confirmation" @click="erase()">{{$t('mcerase.button')}}</v-btn>
            <v-alert
              v-if="confirmationShow"
              class="mt-4"
              type="info">
               {{ $t('mcerase.result') }}
            </v-alert>
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn color="primary" small @click="closeEraseDialog">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  name: 'McErase',
  components: {
  },
  data: () => ({
    confirmationDialogShow: false,
    confirmation: false,
    confirmationShow: false
  }),
  methods: {
    erase() {
        this.$store.commit('erase')
        this.confirmationShow = true
    },
    closeEraseDialog() {
      this.confirmationDialogShow = false;
    }
  }
}
</script>
